import axios from 'axios';
import { newAbortSignal } from '../../utils';
import { SessionStore } from '../../types/store/SessionStore';
import { Account, UpdateAccountManagerSettingsRequest } from '../../types/model/account';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/account`;

export const updateAccountManagerSettings = async (
  accountId: number, 
  data: UpdateAccountManagerSettingsRequest,
): Promise<Account> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem('session') || '{}'
  );

  const finalURL = BASE_URL +  '/' + accountId + '/manager-settings';

  return await axios
    .put<Account>(finalURL, data ,{
      headers: {
        'content-type': 'application/json',
        'x-access-token': session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`))
          : AbortSignal.timeout(
              Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)
            ),
    })
    .then((response) => response.data);
};
